import { Badge, Box, Typography } from '@mui/material';

type EventDotWithTextProps = {
  dotColor: 'warning' | 'info' | 'error' | 'success';
  text: string;
};

export const EventDotWithText = (props: EventDotWithTextProps) => {
  const { dotColor, text } = props;
  return (
    <Box display='flex' flexDirection='row' alignItems='center' ml={2.5}>
      <Badge
        variant='dot'
        color={dotColor}
        sx={{
          mr: 1.5,
          '& .MuiBadge-dot': {
            height: 14,
            width: 14,
            borderRadius: 14,
          },
        }}
      />
      <Typography variant='body1'>{text}</Typography>
    </Box>
  );
};
